export const FAILURE_TYPE_OPTIONS = [
  { value: "No PO", label: "No PO", color: "#ff5722" },
  { value: "Foreign Exchange", label: "Foreign Exchange", color: "#e03131" },
  { value: "Credit Note", label: "Credit Note", color: "#c92a2a" },
  // The list filter still takes `Price mismatch`; the insights endpoint returns the
  // label `Price Difference`. `insightsName` records that pair in one place.
  { value: "Price mismatch", label: "Price Difference", insightsName: "Price Difference", color: "#a61e4d" },
  { value: "VAT mismatch", label: "VAT mismatch", color: "#862e2e" },
];

/**
 * The option a failure-type string belongs to. The backend returns the same type
 * under more than one spelling — the filter value (`Price mismatch`) on some rows
 * and the new name (`Price Difference`) on others — so a string matches an option
 * by its value, its insights name or its label, ignoring case and surrounding
 * spaces.
 */
function findFailureTypeOption(failureType) {
  // Guarded on type, not just truthiness: the field is free text from the API
  // and a number would reach `.toLowerCase()` and throw.
  if (typeof failureType !== "string" || !failureType) return undefined;
  const wanted = failureType.trim().toLowerCase();
  return FAILURE_TYPE_OPTIONS.find((option) =>
    [option.value, option.insightsName, option.label].some(
      (name) => name && name.toLowerCase() === wanted,
    ),
  );
}

/**
 * The name the insights endpoint uses for a failure type, whichever spelling it
 * is given; a type no option knows is passed through unchanged.
 */
export function getFailureTypeInsightsName(failureType) {
  const option = findFailureTypeOption(failureType);
  return option ? (option.insightsName ?? option.value) : failureType;
}

/** What to show for a failure type; the API string is kept as the filter value. */
export function getFailureTypeLabel(failureType) {
  return findFailureTypeOption(failureType)?.label ?? failureType;
}

export function getFailureTypeColor(failureType) {
  if (typeof failureType !== "string" || !failureType) return null;
  return findFailureTypeOption(failureType)?.color ?? "#ff001f";
}
